import { createApp, h, watch } from "vue"
import log from "loglevel"
import { createPinia } from "pinia"
import PrimeVue from "primevue/config"
import { LogLevel } from "@azure/msal-browser"
import { useMsal } from "@wbim/msal-compositional"

import "primeicons/primeicons.css"
import theme from "./utils/theme"
import App from "./App.vue"
import { initAPIClients } from "./utils/apiClients"
import { registerVuetifyPlugin } from "./plugins/vuetify.js"
import router from "./router/index"
import SovereignUniverse from "./utils/SovereignUniverse"

import "animate.css"
import "@/assets/main.css"

// use a consistent window global object instead of vue's auto injection from dotfile,
// dotfile still setup envs on build time but injected to index.html to construct the object
const appConfig = window.appConfig
const clientId = appConfig.VITE_AzureAd__ClientId
const state = useMsal({ auth: { clientId }, system: { loggerOptions: { logLevel: LogLevel.Warning } } })
const msalApp = state.instance

async function initApp() {
  if (!msalApp) {
    throw new Error("MSAL instance is not initialized")
  }
  const app = createApp({ render: () => h(App) })
  registerVuetifyPlugin(app)

  initAPIClients(appConfig)
  const sovereignUniverse = await SovereignUniverse.load()

  app
    .use(router)
    .use(createPinia())
    .use(PrimeVue, { theme: "none" })
    .provide("theme", theme)
    .provide("log", log)
    .provide("msalApp", msalApp)
    .provide("roles", msalApp.getActiveAccount()?.idTokenClaims?.roles ?? [])
    .provide("appConfig", appConfig)
    .provide("sovereignUniverse", sovereignUniverse)
    .mount("#app")
}

watch(
  () => state.isAuthenticated.value,
  async (msalReady) => {
    if (!msalReady) return
    initApp()
  }
)
